import LTR from "@brand-icons/ploom/noise-and-smoke/noise-and-smoke-ltr.svg";

import { iconFactory } from "../iconFactory";

export const NoiseAndSmokeIcon = iconFactory("NoiseAndSmokeIcon", LTR);
